import { FormBuilder } from '@angular/forms';
import { AuthService } from './../../../common/services/permission/authService.service';

import { Component } from '@angular/core';
import { GlobalState } from '../../../global.state';
import { Router } from '@angular/router';
import 'style-loader!./baPageTop.scss';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss'],
})
export class BaPageTop {
  public isScrolled: boolean = false;
  public isMenuCollapsed: boolean = false;
  // now:any;
  fname: any;
  sname: any;
  tname: any;
  userProfile: any;
  login: any;
  date: any;
  now: number = 0;
  form: FormGroup = {} as FormGroup;
  miti: any;
  // Division:any;
  constructor(
    private _state: GlobalState,
    private router: Router,
    private _authService: AuthService,
    private _fb: FormBuilder
  ) {
    this.form = this._fb.group({
      entrymiti: [''],
    });
    setInterval(() => {
      this.now = Date.now();
    }, 1);
    this.userProfile = this._authService.getUserProfile();
    // console.log("userProfileBATOP", this.userProfile);
    if (this.userProfile.Today != null) {
      this.date = this.userProfile.Today.substring(0, 10);
      this.changeServiceDate(this.date);
    }
    this.fname = this.userProfile.companyProfile.splitCompanyName1;
    this.sname = this.userProfile.companyProfile.splitCompanyName2;
    this.tname = this.userProfile.companyProfile.splitCompanyName3;
    this.login = this.userProfile.UserId;
    // this.Division=this.userProfile.DIVISION;
    // this._state.subscribe('menu.isCollapsed', (isCollapsed: boolean) => {
    //   this.isMenuCollapsed = isCollapsed;
      // this.fname=this.masterService.companyProfile.splitCompanyName1;

      // this.now=Date.now();
    // });
  }

  public toggleMenu() {
    console.log('1');
    this.isMenuCollapsed = !this.isMenuCollapsed;
    console.log('2');

    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);

    console.log('3');
    /*let control: any = document.getElementById('leftsidebar');
    console.log({ control: control });
    if (control != null) {
      //control.style.width = '72px';
      console.log({ control: control, isMenuCollapsed: this.isMenuCollapsed });
      if (this.isMenuCollapsed == true) {
        control.style.width = '180px';
        // control.classList.remove('al-sidebar');
        // control.classList.add('sidebar_collapsed');
      } else {
        control.style.width = '72px';
        // control.classList.remove('sidebar_collapsed');
        // control.classList.add('al-sidebar');
      }
    }*/
    return false;
  }

  public scrolledChanged(isScrolled: boolean) {
    this.isScrolled = isScrolled;
  }
  public logout() {
    console.log(this.router);
    this.router.navigate(['login', { logout: 'logout' }]);
  }
  changeServiceDate(value: any) {
    try {
      // alert("reached")
      var adbs = require('ad-bs-converter');
      var adDate = value.replace('-', '/').replace('-', '/');
      var bsDate = adbs.ad2bs(adDate);
      this.form
        .get('entrymiti')
        ?.setValue(
          bsDate.en.year +
            '-' +
            (bsDate.en.month == '1' ||
            bsDate.en.month == '2' ||
            bsDate.en.month == '3' ||
            bsDate.en.month == '4' ||
            bsDate.en.month == '5' ||
            bsDate.en.month == '6' ||
            bsDate.en.month == '7' ||
            bsDate.en.month == '8' ||
            bsDate.en.month == '9'
              ? '0' + bsDate.en.month
              : bsDate.en.month) +
            '-' +
            (bsDate.en.day == '1' ||
            bsDate.en.day == '2' ||
            bsDate.en.day == '3' ||
            bsDate.en.day == '4' ||
            bsDate.en.day == '5' ||
            bsDate.en.day == '6' ||
            bsDate.en.day == '7' ||
            bsDate.en.day == '8' ||
            bsDate.en.day == '9'
              ? '0' + bsDate.en.day
              : bsDate.en.day)
        );

      // this.miti = this.form.value.entrymiti;
      // console.log("date", this.form.value.entrymiti, this.miti)
    } catch (ex) {}
  }
}
